import { Component, OnInit } from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {MultiSelectItemsService} from "../../services/multiSelectItemsService/multi-select-items.service";

@Component({
  selector: 'app-multi-select-floorplan-modal',
  templateUrl: './multi-select-floorplan-modal.component.html',
  styleUrls: ['./multi-select-floorplan-modal.scss']
})
export class MultiSelectFloorplanModal implements OnInit {

  public Yiit = Yiit;
  public floorplanList:ConcreteLayer[];
  public selectedFloorplanId = null;
  public isSwitchToFloorplan = false;

  constructor(private bsModal: EsBsModalService, private cs: ConcreteLayerService, private ms: MultiSelectItemsService) { }

  ngOnInit() {
    this.cs.listChanged.subscribe((list:ConcreteLayer[])=>{
      this.floorplanList = list;
    })
  }

  onSelectedFloorplanChanged(value){
    this.selectedFloorplanId = value;
  }

  confirmFloorplanSelect(){
    if (this.ms.multiSelectMethod == 'move'){
      this.ms.setNewFloorplanForItems(this.selectedFloorplanId, this.isSwitchToFloorplan);
    }

    if (this.ms.multiSelectMethod == 'copy'){
      this.ms.copyItemsToNewFloorplan(this.selectedFloorplanId, this.isSwitchToFloorplan);
    }
    this.bsModal.closeModal();
    this.isSwitchToFloorplan = false;
  }

  isConfirmDisabled(){
    return this.selectedFloorplanId==-1;
  }

}
